// @ts-expect-error JS file
import { DEAL_AMOUNT_CALCULATOR_PROPERTY } from 'crm_data/constants/PortalSettingsKeys';
import { getInMeetingExperienceProxyApiUrl, getProxyApiUrl } from 'in-meeting-experience-ui-components/utils/general';
import { genarateCalculatePropertiesBody } from 'in-meeting-experience-ui-components/utils/lineItems';
import { INTEGRATION_NAME } from '../../constants/google-meet';
import noAuthClient from '../../utils/apiClient';
const API_BASE = getInMeetingExperienceProxyApiUrl();
const API_PROXY_BASE = getProxyApiUrl();
export const getHomeCurrency = () => noAuthClient.get(`${API_BASE}/v1/currencies/information`);
export const getDealAmountCalculationProperty = () => noAuthClient.get(`${API_BASE}/v1/commerce-products-settings/${encodeURIComponent(DEAL_AMOUNT_CALCULATOR_PROPERTY)}`);
export const calculatedProperties = payload => noAuthClient.post(`${API_PROXY_BASE}/inbounddb-objects/v1/calculation-preview/calculated-properties/batch`, {
  data: genarateCalculatePropertiesBody(Object.assign({}, payload, {
    appName: INTEGRATION_NAME
  }))
});